import React from "react";
import { Outlet } from "react-router-dom";
import SideMenu from "../shared/navigation/SideMenu/SideMenu";
import SideNav from "../shared/navigation/SideNav/SideNav";

export default function AppLayout() {

	return (
		<div className="flex h-screen bg-semantic-bg-secondary">
			<SideMenu />

			<div className="flex flex-col flex-1 min-w-0 bg-[var(--semantic-bg-primary)]">
				<SideNav />
				<div className="main-container-global mx-auto w-full max-w-[1600px] px-4">
					<Outlet />
				</div>
			</div>
		</div>
	);
}
